import { NumberInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { FC } from 'react';

import { DayjsUnit } from '@/models/Dayjs.ts';
import { AppointmentBookingFormValues } from '@/models/appointment/AppointmentBookingFormValues.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

interface Props {
    initialValue: number;
    form: UseFormReturnType<AppointmentBookingFormValues>;
}

const DurationInput: FC<Props> = ({ initialValue, form }) => {
    const onChangeDuration = (value: string | number): void => {
        const number_value = Number(value);

        const selected_date = dayjs(form.getValues().date_time);
        if (!selected_date.isValid()) return;

        const end_of_day = selected_date.endOf(DayjsUnit.DAY);
        const max_duration = end_of_day.diff(selected_date, DayjsUnit.MINUTE);

        if (number_value > max_duration) return;

        form.setFieldValue('duration', number_value);
    };

    return (
        <NumberInput
            defaultValue={initialValue}
            label="Dauer"
            {...form.getInputProps('duration')}
            onChange={onChangeDuration}
        />
    );
};

export default DurationInput;
